export const USER_INFO = 'user_info';
export const ESR_BADGE = 'esr_badge';
export const ESTIMATED_TRADE_PRICE_HIGHLIGHT_DISMISSED =
  'estimated_trade_price_highlight_dismissed';
